var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205 5104 c-113 -41 -170 -187 -115 -294 11 -21 396 -569 856 -1217 460 -647 849 -1201 866 -1229 16 -29 34 -67 41 -86 8 -24 13 -307 17 -1073 6 -1150 1 -1075 70 -1142 46 -45 108 -67 168 -60 68 9 1027 378 1070 412 19 15 43 46 53 69 18 39 19 81 19 861 0 896 1 904 58 1009 16 29 407 586 869 1237 462 651 848 1199 857 1218 10 18 20 56 23 85 7 72 -34 149 -102 191 l-48 30 -2331 2 c-2020 1 -2336 0 -2371 -13z m4481 -346 c-225 -315 -1549 -2183 -1572 -2220 -42 -66 -72 -130 -96 -210 -22 -72 -22 -82 -28 -898 l-5 -825 -425 -162 -425 -161 -5 996 c-6 1096 -2 1025 -69 1167 -38 82 35 -23 -886 1275 -435 613 -795 1121 -799 1128 -6 9 435 12 2188 12 l2196 0 -74 -102z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.b8fe8a8dc4c4cf5346d0f33a1449ca43.svg";
export { ForwardRef as ReactComponent };